// userUtils.js
// Centralized utility for fetching user details in Redbird Markets

import { db } from "../services/firebase";
import { doc, getDoc } from "firebase/firestore";

/**
 * Fetch user details by userId
 * @param {string} userId
 * @returns {Promise<Object|null>} user object or null
 */
export async function getUserById(userId) {
  if (!userId) {
    return null;
  }
  
  const userRef = doc(db, "users", userId);
  const userSnap = await getDoc(userRef);
  
  if (!userSnap.exists()) {
    return null;
  }
  
  const userData = userSnap.data();
  // Create a display name from available fields (fallback hierarchy)
  const displayName = userData.name || 
                     userData.displayName || 
                     (userData.firstName && userData.lastName ? `${userData.firstName} ${userData.lastName}` : null) ||
                     userData.firstName ||
                     userData.email ||
                     'Unknown User';
  
  const result = { 
    ...userData, 
    id: userSnap.id,
    name: displayName // Ensure name field is always present
  };
  
  return result;
}

/**
 * Fetch seller details by listingId
 * @param {string} listingId
 * @returns {Promise<Object|null>} seller object or null
 */
export async function getSellerByListingId(listingId) {
  if (!listingId) return null;
  const listingRef = doc(db, "listings", listingId);
  const listingSnap = await getDoc(listingRef);
  if (!listingSnap.exists()) return null;
  const listingData = listingSnap.data();
  // Support both sellerId (production) and createdBy (legacy)
  const sellerUserId = listingData.sellerId || listingData.createdBy;
  return getUserById(sellerUserId);
}
